// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";

// ✅ Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAE9gMlkCyC0UHUVE02oyqQKwWzvp2V_6Y",
  authDomain: "earnova-new.firebaseapp.com",
  projectId: "earnova-new",
  storageBucket: "earnova-new.appspot.com",
  messagingSenderId: "306044345203",
  appId: "1:306044345203:web:e64879f3800166f0504306",
  measurementId: "G-EFSP7Y06QF"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);
export const storage = getStorage(app);

export { app, auth, firestore };
